import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";
import { usePatientContext } from "../../../Context/PatientContext";
import SideMenu from "../../Elements/SideMenu";
import BreadCrumb from "../../Elements/Breadcrumb";
import PatientInfo from "../../Elements/PatientInfo/index";
import PatientSummary from "../../Elements/PatientSummary";
import ClinicalParameters from "../../Elements/ClinicalParameters";
import TreatmentGlance from "../../Elements/TreatmentGlance";
import PatientVisitRecords from "../../Elements/PatientVisitRecords";
// import RightSectionPatient from "../../Elements/RightSectionPatient";
// import ChatSection from "../../Elements/ChatSection";
import InvestigationAndTreatment from "../../Elements/InvestigationAndTreatment";
import "./style.css";
import CaseSummary from "../../Elements/CaseSummary";
import { getPatientById, getPatientTimeline } from "../../../Services";
import SharingHistory from "../../Elements/SharingHistory";
import RightSectionCommon from "../../Elements/RightSectionCommon";

const PatientDetails = () => {
  const { patientId } = useParams(); /* Read dynamic URL params */
  const { physician } = useAuth();
  const [viewAllClicked, setViewAllClicked] = useState(false);
  const [isPatientVisitRecordVisible, setIsPatientVisitRecordVisible] =
    useState(false);
  const {
    patientDetails,
    patientTimeline,
    updatePatientDetails,
    updatePatientTimeline,
  } = usePatientContext();
  const [breadcrumbContent, setBreadcrumbContent] = useState([
    { name: "Dashboard", url: "/dashboard" },
  ]);

  // const handleViewAllClick = () => {
  //   setViewAllClicked(true);
  //   setIsPatientVisitRecordVisible(false);

  //   if (!viewAllClicked) {
  //     setBreadcrumbContent([
  //       { name: "Dashboard", url: "/dashboard" },
  //       { name: "Patient Visit Management" },
  //     ]);
  //   }
  // };

  const handlePatientVisitRecordSwitch = () => {
    setIsPatientVisitRecordVisible(true);
    setViewAllClicked(false);

    if (isPatientVisitRecordVisible) {
      setBreadcrumbContent([
        { name: "Dashboard", url: "/dashboard" },
        {
          name: `${patientDetails.firstName} ${patientDetails.lastName}`,
          url: `/patient/${patientId}`,
        },
        { name: "Patient Visit Management" },
      ]);
    } else {
      setBreadcrumbContent([
        { name: "Dashboard", url: "/dashboard" },
        {
          name: `${patientDetails.firstName} ${patientDetails.lastName}`,
        },
      ]);
    }
  };

  const [displayCaseSummary, setDisplayCaseSummary] = useState(false);
  const [displaySharingHistory, setDisplaySharingHistory] = useState(false);

  const getPatientDetails = async () => {
    try {
      const detailsResponse = await getPatientById(
        physician.physician._id,
        patientId
      );
      const timelineResponse = await getPatientTimeline(
        physician.physician._id,
        patientId
      );
      updatePatientDetails(detailsResponse.data);
      updatePatientTimeline(timelineResponse.data);
      setBreadcrumbContent([
        { name: "Dashboard", url: "/dashboard" },
        {
          name: `${detailsResponse.data.firstName} ${detailsResponse.data.lastName}`,
        },
      ]);
    } catch (error) {
      console.error("Error fetching patient details:", error);
    }
  };

  useEffect(() => {
    getPatientDetails();
  }, []);

  const handleScreenSwitch = () => {
    if (!displayCaseSummary) {
      setBreadcrumbContent([
        { name: "Dashboard", url: "/dashboard" },
        {
          name: `${patientDetails.firstName} ${patientDetails.lastName}`,
          url: `/patient/${patientId}`,
        },
        { name: "Case Summary" },
      ]);
    } else {
      setBreadcrumbContent([
        { name: "Dashboard", url: "/dashboard" },
        {
          name: `${patientDetails.firstName} ${patientDetails.lastName}`,
        },
      ]);
    }
    setDisplayCaseSummary(!displayCaseSummary);
  };

  const handleSharingHistory = () => {
    if (!displaySharingHistory) {
      setBreadcrumbContent([
        { name: "Dashboard", url: "/dashboard" },
        {
          name: `${patientDetails.firstName} ${patientDetails.lastName}`,
          url: `/patient/${patientId}`,
        },
        { name: "Sharing History" },
      ]);
    } else {
      setBreadcrumbContent([
        { name: "Dashboard", url: "/dashboard" },
        {
          name: `${patientDetails.firstName} ${patientDetails.lastName}`,
        },
      ]);
    }
    setDisplaySharingHistory(!displaySharingHistory);
  };

  const updateBreadCrumb = (content) => {
    setBreadcrumbContent(content);
  };

  return (
    //Patient Details Container
    <div className="container">
      <SideMenu />
      <div className="patient-details-frame">
        <div className="patient-demograph-details-frame">
          <BreadCrumb contents={breadcrumbContent} />
          <PatientInfo screen="details" />
          {displayCaseSummary ? (
            <CaseSummary handleScreenSwitch={handleScreenSwitch} />
          ) : displaySharingHistory ? (
            <SharingHistory handleSharingHistory={handleSharingHistory} />
          ) : (
            <div className="patient-report-details-frame" id="report-details">
              <div className="patient-reports-sub-left-frame">
                <TreatmentGlance />
              </div>
              <div className="patient-reports-sub-right-frame">
                {viewAllClicked && !isPatientVisitRecordVisible ? (
                  <PatientVisitRecords
                    handleBack={handlePatientVisitRecordSwitch}
                  />
                ) : (
                  <>
                    <div
                      className="patient-reports-upper-container"
                      id="summary-and-parameters"
                    >
                      {patientDetails && patientTimeline ? (
                        <>
                          <PatientSummary
                            handleScreenSwitch={handleScreenSwitch}
                            handleSharingHistory={handleSharingHistory}
                          />
                          <ClinicalParameters />
                        </>
                      ) : (
                        <p>Loading patient data...</p>
                      )}
                    </div>
                    <div className="IT-table">
                      <InvestigationAndTreatment
                        updateBreadCrumb={updateBreadCrumb}
                        data={patientTimeline}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <div id="right-section">
        {/* disabled for phase 1 */}
        {/* <RightSectionPatient
          onViewAllClick={handleViewAllClick}
          viewAllClicked={viewAllClicked}
        /> */}
        <RightSectionCommon />
        {/* <div className="right-section-bottom">
          <ChatSection />
        </div> */}
      </div>
    </div>
  );
};

export default PatientDetails;
